/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMediaLinksData } from './media-links.data';
import { IMediaLinksProps } from './media-links.props.autogenerated';

export interface IMediaLinksViewProps extends IMediaLinksProps<IMediaLinksData> {
    data: any;
}

/**
 *
 * MediaLinks component
 * @extends {React.PureComponent<IMediaLinksProps<IMediaLinksData>>}
 */
class MediaLinks extends React.PureComponent<IMediaLinksProps<IMediaLinksData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MediaLinks;
